import { SyncAlt } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { FormAutocomplete } from '../../../../view/design/form/FormAutocomplete';
import { FormIcon } from '../../../../view/design/form/FormIcon';
import { FormTextLabel } from '../../../../view/design/form/FormTextLabel';
import { FormTitleText } from '../../../../view/design/form/FormTitleText';
import {
  IApplicationInfoDetailsFormProperties,
  JiraPrioritiesAutocomplete,
} from '../../../../view/user/page/application/info/parts/application/ApplicationInfoDetailsForm';
import { RiskManagerPriorityByRequirementThreatDomain } from './store/RiskManagerPriorityByRequirementThreatDomain';

export const RiskManagerPriorityByRequirementThreat = observer(({ domain }: IApplicationInfoDetailsFormProperties) => {
  const [extensionsDomain] = useState<RiskManagerPriorityByRequirementThreatDomain>(
    new RiskManagerPriorityByRequirementThreatDomain(domain),
  );

  const jiraProjectPriorities = domain.ui.jiraProjectPriorities.value;
  const jiraPrioritiesAutocompleteValues: any = [{ id: null, name: '' }, ...jiraProjectPriorities].map((item) => ({
    name: item.name || '',
    value: item.id || '',
  }));

  const projectId = domain.ui.editJiraTaskManager.entity.settings?.value?.projectId;
  const issueTypeId = domain.ui.editJiraTaskManager.entity.settings?.value?.issue?.type?.id;

  useEffect(() => {
    if (projectId) {
      const loadData = async () => {
        await domain.loadJiraPriorities();
        await extensionsDomain.loadRequirementThreatData();
      };
      loadData();
    }
  }, [projectId, issueTypeId, domain]);

  useEffect(() => {
    const requirementThreatData = extensionsDomain.requirementThreatData.value
    extensionsDomain.requirementThreatData.setValue([])
    setTimeout(() => {
      extensionsDomain.requirementThreatData.setValue(requirementThreatData)
    }, 1)
  }, [domain.isTemplateJira.value]);

  return extensionsDomain.requirementThreatData.value.length > 0 ? (
    <>
      <Grid container direction={'column'}>
        <FormTitleText text={'Приоритет уровню уязвимостей требований'} />
        {extensionsDomain.requirementThreatData.value.map((levelData) => {
          const isLoading = domain.ui.isLoadingJiraPriorities.value;
          let selectedPriorityId =
            domain.ui.editJiraTaskManager?.entity?.settings?.value?.prioritiesMap?.find(
              (link) => link.tagId === levelData.levelPseudoId,
            )?.externalPriorityId || null;

          if (domain.isTemplateJira.value) {
            const templatePriority = domain.ui.editJiraTaskManager.entity.settings?.value?.prioritiesMap.find((priority) => {
              return priority.tagId === levelData.levelPseudoId;
            })
            const externalPriorityID = jiraPrioritiesAutocompleteValues.filter((item) => item.name === templatePriority?.name).map((item) => item.value)[0];
            if (templatePriority) {
              templatePriority.externalPriorityId = externalPriorityID;
            }
            selectedPriorityId = externalPriorityID;
          }
          return (
            <Grid item>
              <Grid xs={8} container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
                <Grid item>
                  <FormTextLabel text={levelData.name} />
                </Grid>
                <Grid item>
                  <FormIcon>
                    <SyncAlt color={!!selectedPriorityId ? 'secondary' : 'disabled'} />
                  </FormIcon>
                </Grid>
                <Grid item xs={4}>
                  <FormAutocomplete
                    values={isLoading ? [] : jiraPrioritiesAutocompleteValues}
                    onChangeSelect={(newValue) => {
                      if (domain.ui.editJiraTaskManager.entity.settings?.value) {
                        if (!domain.ui.editJiraTaskManager.entity.settings?.value?.prioritiesMap) {
                          domain.ui.editJiraTaskManager.entity.settings.value.prioritiesMap = [];
                        }
                        const selectedJiraPriorityIndex =
                          domain.ui.editJiraTaskManager.entity.settings?.value?.prioritiesMap.findIndex(
                            (item) => item.tagId === levelData.levelPseudoId,
                          );
                        if (!newValue?.value) {
                          domain.ui.editJiraTaskManager.entity.settings.value.prioritiesMap.splice(
                            selectedJiraPriorityIndex,
                            1,
                          );
                        } else {
                          if (selectedJiraPriorityIndex !== -1) {
                            domain.ui.editJiraTaskManager.entity.settings.value.prioritiesMap[
                              selectedJiraPriorityIndex
                            ].externalPriorityId = newValue.value;
                            domain.ui.editJiraTaskManager.entity.settings.value.prioritiesMap[
                              selectedJiraPriorityIndex
                            ].name = newValue.name;
                          } else {
                            domain.ui.editJiraTaskManager.entity.settings.value.prioritiesMap.push({
                              isDefault: false,
                              orderIndex: 0,
                              externalPriorityId: newValue.value,
                              tagId: levelData.levelPseudoId || '',
                              name: newValue.name,
                            });
                          }
                        }
                      }
                    }}
                    key={`jira-priority-map-${levelData.levelPseudoId}`}
                    selected={selectedPriorityId}
                    label="Приоритет в Jira"
                    onOpen={() => {
                      domain.removeJiraValidationErrors();
                    }}
                    // onClose={() => changeIsloading(false)}
                    isLoading={isLoading}
                    loadingText={'Загрузка приоритетов'}
                  />
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <JiraPrioritiesAutocomplete domain={domain} />
    </>
  ) : (
    <JiraPrioritiesAutocomplete domain={domain} />
  );
});
